import script from "./DateRangePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./DateRangePicker.vue?vue&type=script&setup=true&lang=js"

import "./DateRangePicker.vue?vue&type=style&index=0&id=0888fc40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0888fc40"]])

export default __exports__